import { Component, inject } from '@angular/core';
import { PileTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PileTypeCreateDto,
  PileTypeDto,
  PileTypeExcelDownloadDto,
  PileTypeUpdateDto,
} from '../proxy/planning/dtos/pile-type';
import { PILETYPE_CONFIG, PILETYPE_FIELDS } from './pile-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-pile-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PileTypeService, ConfirmationService],
  templateUrl: './pile-type.html',
  styleUrl: './pile-type.scss',
})
export class PileType extends BaseCrudComponent<
  PileTypeDto,
  PileTypeCreateDto,
  PileTypeUpdateDto,
  PileTypeExcelDownloadDto
> {
  service = inject(PileTypeService);
  config = PILETYPE_CONFIG;
  fields = PILETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PileTypeDto): PileTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PileType';
  }
}
